"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var template = require("@reverbdotcom/url-template");
var DEFAULT_UPLOAD_IMAGE_CDN = 'https://res.cloudinary.com/reverb-cms';
// the second argument here is temporary until we unify CDN paths between CMS and LP
function imageUploadURL(image_key, cdn) {
    if (cdn === void 0) { cdn = DEFAULT_UPLOAD_IMAGE_CDN; }
    var path = template.parse('/image/upload/{image_key}').expand({ image_key: image_key });
    return "" + cdn + path;
}
exports.imageUploadURL = imageUploadURL;
exports.YOUTUBE_IMAGE = template.parse('https://img.youtube.com/vi/{slug}/hqdefault.jpg');
exports.YOUTUBE_VIDEO = template.parse('https://www.youtube.com/embed/{slug}{?autoplay}');
exports.VIMEO_VIDEO = template.parse('https://player.vimeo.com/video/{slug}');
exports.ITEM_WITH_SLUG_ROUTE = template.parse('/item/{id}-{slug}{?show_sold}');
exports.BRAND_ROUTE = template.parse('/brand/{brand_slug}{?product_type,category}');
exports.SHOP_PATH = template.parse('/shop/{slug}');
function cmsEditRoute(uuid) {
    var path = template.parse('/pages/{uuid}/edit').expand({ uuid: uuid });
    return "" + process.env.CMS_ADMIN_HOST + path;
}
exports.cmsEditRoute = cmsEditRoute;
exports.PASSWORD_RESET_PATH = '/forgot_password';
exports.FACEBOOK_AUTH_PATH = '/auth/facebook';
exports.TERMS_OF_USE_PATH = '/page/terms';
exports.PRIVACY_POLICY_PATH = '/page/privacy';
exports.GDPR_POLICY_PATH = '/page/eu-data-transfer-GDPR';
exports.CORE_MARKETPLACE_URL = process.env.CORE_HOST + "/marketplace";
var CMS_PAGE_PATH = template.parse('/{path}/{slug}');
function getPageTypePath(pageType) {
    if (pageType === 'article')
        return 'articles';
    if (pageType === 'crate')
        return 'handpicked';
    return 'c';
}
function CMSPageURL(page) {
    var host = page.channels[0] === 'lp' ? process.env.LP_HOST : process.env.CORE_HOST;
    var slug = page.slug, pageType = page.pageType;
    return host + CMS_PAGE_PATH.expand({ slug: slug, path: getPageTypePath(pageType) });
}
exports.CMSPageURL = CMSPageURL;
function marketplaceQuery(query) {
    return "/marketplace?query=" + encodeURIComponent(query);
}
exports.marketplaceQuery = marketplaceQuery;
//# sourceMappingURL=url_helpers.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/url_helpers.js
// module id = tNfo
// module chunks = 20 21